/**
 * This plugin is used to track pageviews on Universal Analytics.
 * After the GA4 migration this plugin is not necessary and should be removed.
 */
import { GTM_PAGEVIEW_EVENT_NAME, GA4_MIGRATION } from '@/constants/global';
import { isPDP, setUserDataLayer } from '../util/global';

export default function (ctx) {
  const isGa4Enabled = ctx.store.getters['experiments/getExperimentVariant'](GA4_MIGRATION) === 'enabled';
  let isFirstLoad = true;

  ctx.app.router.beforeEach((_, __, next) => {
    if (isFirstLoad) {
      next();
      return;
    }

    if (!isGa4Enabled) {
      ctx.$gtm.push(function reset() {
        this.reset();
      });
    }
    next();
  });

  ctx.app.router.afterEach((to) => {
    /**
     * Do not track pageviews when nuxt loads the very first time to avoid
     * duplicated records on GA, this is happening because we're initializing
     * manually gtm on the base layout.
     *
     * TODO: We should remove this flag when all pages are already migrated to
     * Nuxt and if we use the autoinit gtm flag, also we should update the
     * `Pro - GA - Pageview` GTM tag that tracks the pageviews and use only the
     * `pageview` custom event for nuxt, then we should remove the generic GA
     * trigger (All Pages).
     *
     * TODO: Use runtimeconfig to setup gtm module.
     */
    if (isFirstLoad) {
      isFirstLoad = false;
      return;
    }

    const { $gtm, $gtag, store } = ctx;
    const { user } = store.state.session;
    const urlData = new URL(window.location.href);
    const pageUrl = urlData.pathname + urlData.search;
    const TIMEOUT_MS = 250;
    const pageviewParameters = {
      pageType: 'PageView',
      pageUrl,
      pageLocation: window.location.href,
      pagePath: pageUrl,
      routeName: to.name || '',
    };

    if (isGa4Enabled) {
      setTimeout(() => {
        let contentGroup = '';
        let contentGroup2 = '';

        if (isPDP(pageUrl)) {
          const dataLayerCopy = [...window.dataLayer].reverse();
          const lastViewItem = dataLayerCopy.find((x) => x[1] === 'view_item')?.[2] || {};
          contentGroup = lastViewItem.content_group;
          contentGroup2 = lastViewItem.content_group_2;
        } else {
          // Clear content groups for non PDP pages
          $gtag('set', {
            contentGroup1: contentGroup,
            contentGroup2,
          });
        }

        $gtag('event', GTM_PAGEVIEW_EVENT_NAME, {
          pageType: 'PageView',
          content_group: contentGroup,
          content_group_2: contentGroup2,
          pageTitle: document.title,
          ...pageviewParameters,
        });
      }, TIMEOUT_MS);
    } else {
      // Set datalayer for user info
      setUserDataLayer(user, $gtm);

      // Inside a timeout to get the current page title.
      setTimeout(() => {
        $gtm.push({
          event: GTM_PAGEVIEW_EVENT_NAME,
          ...pageviewParameters,
        });
      }, TIMEOUT_MS);
    }

    store.dispatch('nextExperimentsRedirects');
    store.dispatch('experiments/enroll');
  });
}
